import { useEffect } from 'react';
import { resetHistory } from './historyStore';

/**
 * R9 (AP-773): the history belongs to one study. Mount once on the reader
 * page; when the selected study changes, both stacks are discarded. (Reload
 * needs nothing — the history is in memory only.)
 */
export function useStudyHistoryScope(studyUuid: string | undefined): void {
  useEffect(() => {
    resetHistory();
    return () => resetHistory();
  }, [studyUuid]);
}
